module.exports = __webpack_public_path__ + "img/MiniJean.f3bb28d5.png";